import React, { useEffect, useState } from 'react'
import { Link, Links } from 'react-router-dom'

import { getAllTestimonialApi, getAllFaqsApi } from '../../apis/services'
import Spinner from '../Spinner';
import { errorResponseHandler } from '../../apis/http';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import Marquee from 'react-fast-marquee';
import "swiper/css";
import "swiper/css/pagination";


const TheApp = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [allFaqs, setAllFaqs] = useState([]);
    const [loading, setLoading] = useState(true)

    const fetchFaqs = async () => {
        try {
            const response = await getAllFaqsApi();
            setAllFaqs(response?.faqs || []);
        } catch (error) {
            errorResponseHandler(error)
        }
    };

    const fetchTestimonials = async () => {
        try {
            const response = await getAllTestimonialApi();

            setTestimonials(response.testimonials)
        } catch (error) {
            errorResponseHandler(error)
        }

    }



    useEffect(() => {
        setLoading(true);

        Promise.all([fetchFaqs(), fetchTestimonials()])
            .then(([faqs, testimonials]) => {

            })
            .catch((err) => {

                errorResponseHandler(err)
            })
            .finally(() => {
                setLoading(false); // always runs
            });
    }, []);

    if (loading) {
        return <Spinner />
    }

    return (
        <>
            <input type="checkbox" id="mpclose" />
            <div class="hero hero-app bg-section dark-section">
                <div class="container">
                    <div class="row align-items-center  justify-content-center">
                        <div class="col-lg-12">
                            <div class="hero-content text-center">
                                <div class="section-title text-center">
                                    <div class="flask-img three-blocks-x">
                                        <img src="images/flask-1.png" alt="" />
                                    </div>

                                    <h1 class="text-anime-style-3" data-cursor="-opaque">IngredientIQ App — Your Ingredients, Decoded in Real Time</h1>
                                    <p class="wow fadeInUp" data-wow-delay="0.2s">Install IngredientIQ and get science-backed, AI-powered ingredient analysis tailored to your unique
                                        diet, allergies, and health profile.</p>

                                </div>


                                <div class="hero-content-body justify-content-center text-center wow fadeInUp" data-wow-delay="0.4s">

                                    <div class="text-center">
                                        <a href="#!" class="">
                                            <img src="images/app-store.png" alt="" />
                                        </a>
                                    </div>

                                    <div class="text-center">
                                        <a href="#!" class="">
                                            <img src="images/google-play.png" alt="" />
                                        </a>
                                    </div>

                                </div>
                                <p class="mt-4 text-black">Trusted by global health experts. Smarter with every scan and every community insight.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class=" bg-section dark-section">

                <Marquee gradient={false} speed={50}>
                    <div class="marquee-inner">
                        <img src="images/app-1.webp" alt="Sign in" />
                        <img src="images/app-2.webp" alt="Onboarding Questionnaire" />
                        <img src="images/app-3.webp" alt="Onboarding Questionnaire" />
                        <img src="images/app-4.webp" alt="Scan" />
                        <img src="images/app-5.webp" alt="Analysis Result" />
                        <img src="images/app-6.webp" alt="Subscription" />
                        <img src="images/app-7.webp" alt="Scan History" />
                        <img src="images/app-8.webp" alt="Product details" />
                        <img src="images/app-9.webp" alt="Scan products" />
                        <img src="images/app-10.webp" alt="My ingredients" />
                    </div>

                </Marquee>


            </div>

            <div class="mg-feature-section">
                <div class="container">
                    <div class="mg-feature-top">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="section-title text-center mxw-565 mx-auto">

                                    <h2>Key Benefits Trio</h2>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="mg-feature-service-outer">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-4 col-sm-8 mg-feature-main">
                                <div class="mg-feature-box">
                                    <div class="card">
                                        <div class="card-body text-start">
                                            <img src="images/hourglass.gif" alt="" />
                                            <h6 class="card-title">Real-Time & Personal</h6>
                                            <p class="card-text">Scan any food label — get instant ingredient breakdowns personalized to your dietary restrictions and
                                                health conditions.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-8 mg-feature-main">
                                <div class="mg-feature-box">
                                    <div class="card">
                                        <div class="card-body text-start">
                                            <img src="images/trusted.gif" alt="" />
                                            <h6 class="card-title">Science & Regulatory Trust</h6>
                                            <p class="card-text">Cross-checked against leading medical research and global food safety guidelines. IngredientIQ never
                                                sells or promotes brands.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-8 mg-feature-main">
                                <div class="mg-feature-box">
                                    <div class="card">
                                        <div class="card-body text-start">
                                            <img src="images/artificial-intelligence.gif" alt="" />
                                            <h6 class="card-title">Smarter AI</h6>
                                            <p class="card-text">Your feedback helps IngredientIQ get better. The more you scan, the sharper your personalized
                                                Go/No-Go checks become.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="work-process-section section-padding">
                <div class="work-process-container-wrapper style1">
                    <div class="container">
                        <div class="section-title text-center mxw-565 mx-auto">
                            <h2 class="title wow fadeInUp" data-wow-delay=".4s"> How It Works </h2>
                        </div>
                        <div class="work-process-wrapper style1">
                            <div class="shape"><img src="images/workProcessShape1_1.png" alt="shape" /></div>
                            <div class="row">
                                <div class="col-xl-4">
                                    <div class="work-process-box style1 wow fadeInUp" data-wow-delay=".2s">
                                        <div class="icon-box">
                                            <img src="images/qr-code.gif" alt="" />
                                        </div>
                                        <div class="step">STEP - 01</div>
                                        <div class="title">Scan Instantly</div>
                                        <div class="text">Use your phone to scan any ingredient list. Our AI reads it in seconds.</div>
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="work-process-box style1 child2 wow fadeInUp" data-wow-delay=".4s">
                                        <div class="icon-box">
                                            <img src="images/analyze.gif" alt="" />
                                        </div>
                                        <div class="step">STEP - 02</div>
                                        <div class="title">Personalized Analysis</div>
                                        <div class="text">IngredientIQ matches each ingredient to your unique profile — allergies, diets, health goals.</div>
                                    </div>
                                </div>
                                <div class="col-xl-4">
                                    <div class="work-process-box style1 wow fadeInUp" data-wow-delay=".6s">
                                        <div class="icon-box">
                                            <img src="images/choosing.gif" alt="" />
                                        </div>
                                        <div class="step">STEP - 03</div>
                                        <div class="title">Clear Go/No-Go Decision</div>
                                        <div class="text">See an instant Go/No-Go status so you can shop smarter — anywhere, anytime.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <div class="how-it-work bg-section dark-section">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="section-title mb-0">

                                <h2 class="text-anime-style-3" data-cursor="-opaque">Built for trust. Powered by science.</h2>
                                <p class="text-white">IngredientIQ is fully independent. We accept no money from brands or manufacturers — so your
                                    insights stay objective and transparent. Our AI verifies ingredient safety against trusted sources and
                                    continuously learns from our global community’s real feedback.</p>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="section-title-content text-white wow fadeInUp" data-wow-delay="0.2s">
                                <div class="how-it-work-steps">
                                    <div class="how-work-step-item wow fadeInUp">
                                        <div class="icon-box">
                                            <img src="images/speaker.png" alt="" />

                                            <div class="how-work-no">
                                                <h3>1</h3>
                                            </div>
                                        </div>
                                        <div class="how-work-content">
                                            <h3>Independent</h3>
                                        </div>
                                    </div>

                                    <div class="how-work-step-item wow fadeInUp" data-wow-delay="0.2s">
                                        <div class="icon-box">
                                            <img src="images/document.png" alt="" />

                                            <div class="how-work-no">
                                                <h3>2</h3>
                                            </div>
                                        </div>
                                        <div class="how-work-content">
                                            <h3>Verified Research</h3>
                                        </div>
                                    </div>

                                    <div class="how-work-step-item wow fadeInUp" data-wow-delay="0.4s">
                                        <div class="icon-box">
                                            <img src="images/ai.png" alt="" />

                                            <div class="how-work-no">
                                                <h3>3</h3>
                                            </div>
                                        </div>
                                        <div class="how-work-content">
                                            <h3>No Paid Product Placements</h3>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">


                        </div>
                    </div>
                </div>
            </div>
            <section class="pricing">
                <div class="container">
                    <div class="section-title text-center mxw-565 mx-auto">
                        <h2 class="text-center">Choose Your Plan</h2>
                        <p class="text-center">Free forever with optional premium upgrades for power users</p>
                    </div>
                    <div class="table-responive">
                    <table class="pricing-table">
                        <thead>
                            <tr>
                                <th>Feature</th>
                                <th>Freemium</th>

                                <th>Premium Monthly</th>
                                <th>Premium Yearly</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="plan-name">Plan</td>
                                <td class="price">$0</td>

                                <td class="price">$19.99/mo</td>

                                <td class="price">$199.99/yearly</td>
                            </tr>
                            <tr>
                                <td>Barcode Scanning</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Basic Ingredient Analysis</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Allergy Alerts</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Personal Health Profile</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Save Favorite Products</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Advanced Diet Tracking</td>
                                <td class="cross">✗</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Multi-Profile Support</td>
                                <td class="cross">✗</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Detailed Nutrition Insights</td>
                                <td class="cross">✗</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Offline Access</td>
                                <td class="cross">✗</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td>Priority Support</td>
                                <td class="cross">✗</td>
                                <td class="check">✓</td>
                                <td class="check">✓</td>

                            </tr>
                            <tr>
                                <td></td>
                                <td><a href="#" class="btn btn-dark rounded-5">Get Free</a></td>
                                <td><a href="#" class="btn btn-accent">Go Premium Monthly</a></td>
                                <td><a href="#" class="btn btn-accent">Go Premium Yearly</a></td>

                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </section>
            <section class="section-padding-who">
                <div class="container section-title text-center mxw-565 mx-auto">
                    <h2 class="text-center mb-5">Who Uses IngredientIQ</h2>
                    <div class="use-cases">
                        <div class="use-case">
                            <i class="fas fa-baby"></i>
                            <h4>Parents</h4>
                            <p>Keep your children safe from allergens and make healthier food choices for your family.</p>
                        </div>
                        <div class="use-case">
                            <i class="fas fa-heartbeat"></i>
                            <h4>Chronic Conditions</h4>
                            <p>Manage diabetes, hypertension, IBS, and other conditions with food choices that support your health.</p>
                        </div>
                        <div class="use-case">
                            <i class="fas fa-running"></i>
                            <h4>Fitness Enthusiasts</h4>
                            <p>Achieve your fitness goals by tracking macros, avoiding unwanted ingredients, and finding optimal nutrition.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div class="our-testimonial ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="testimonial-content">
                                <div class="section-title text-center">

                                    <h2 class="text-anime-style-3" data-cursor="-opaque">Trusted by 1,000+ Users</h2>
                                    <p>Rated 4.8/5 stars by health professionals and consumers</p>
                                </div>
                                <div class="testimonial-boxes">
                                    <div class=" hero-slider-layout ">
                                        <div class="container">
                                            <div>
                                                <div >
                                                    <Swiper
                                                        modules={[Pagination, Autoplay]}
                                                        pagination={{ clickable: true }}
                                                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                                                        loop={true}
                                                        spaceBetween={30}
                                                        breakpoints={{
                                                            0: { slidesPerView: 1 },
                                                            768: { slidesPerView: 2 },
                                                            1024: { slidesPerView: 3 },
                                                        }}
                                                        className="testimonial-swiper"
                                                    >
                                                        {testimonials?.map((value, index) => (
                                                            <SwiperSlide key={index}>
                                                                <div className="testimonial-item bg-cyan-100 rounded-xl p-6 shadow-md h-full flex flex-col justify-between">
                                                                    {/* Rating Stars */}
                                                                    <div className="testimonial-rating flex mb-4 text-cyan-700">
                                                                        {Array.from({ length: value.rating }).map((_, i) => (
                                                                            <i key={i} className="fa-solid fa-star mr-1"></i>
                                                                        ))}
                                                                    </div>

                                                                    {/* Content */}
                                                                    <div className="testimonial-info text-gray-800 flex-1 mb-4">
                                                                        <p>{value.content}</p>
                                                                    </div>

                                                                    {/* Author */}
                                                                    <div className="testimonial-author-box flex items-center gap-3 mt-4">
                                                                        <div className="testimonial-author-iamge">
                                                                            <figure className="image-anime">
                                                                                <img
                                                                                    src={value.image}
                                                                                    alt={value.name}

                                                                                />
                                                                            </figure>
                                                                        </div>
                                                                        <div className="testimonial-author-content">
                                                                            <h3 className="font-semibold">{value.name}</h3>
                                                                            <p className="text-sm text-gray-600">{value.role}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>



                                                </div>
                                                <div class="hero-pagination"></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <div class="our-faqs">
                <div class="container">
                    <div class="row justify-content-center">


                        <div class="col-lg-8">
                            <div class="faqs-content">
                                <div class="section-title text-center">
                                    <h2 class="text-anime-style-3" data-cursor="-opaque">App-specific FAQs </h2>
                                </div>

                                <div className="faq-accordion" id="faqaccordion">
                                    {allFaqs.length > 0 &&
                                        allFaqs.slice(0, 4).map((value, index) => {
                                            const headingId = `heading${index}`;
                                            const collapseId = `collapse${index}`;
                                            return (
                                                <div
                                                    className="accordion-item wow fadeInUp"
                                                    data-wow-delay="0.2s"
                                                    key={index}
                                                >
                                                    <h2 className="accordion-header" id={headingId}>
                                                        <button
                                                            className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#${collapseId}`}
                                                            aria-expanded={index === 0 ? "true" : "false"}
                                                            aria-controls={collapseId}
                                                        >
                                                            {value.question}
                                                        </button>
                                                    </h2>
                                                    <div
                                                        id={collapseId}
                                                        className={`accordion-collapse collapse ${index === 0 ? "show" : ""
                                                            }`}
                                                        aria-labelledby={headingId}
                                                        data-bs-parent="#faqaccordion"
                                                    >
                                                        <div className="accordion-body">
                                                            <p>{value.answer}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                                <div class="about-us-btn mt-4 text-center">
                                    <Link to="faqs" class="btn-default">See All FAQ's</Link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <section class="cta-banner">
                <div class="cta-content">
                    <h1 class="cta-headline">Ready to trust what you eat?</h1>
                    <p class="cta-subtext">Install IngredientIQ today and take control of what you <br />eat — with confidence, science, and a
                        clear Go/No-Go answer every time.</p>

                    <div class="app-badges">
                        <a href="#" class="app-badge" aria-label="Download on the App Store">
                            <img src="images/app-store.png" alt="Download on the App Store" class="app-badge-img" />
                        </a>                                                                        <a href="#" class="app-badge" aria-label="Download on the App Store" />


                        <a href="#" class="app-badge" aria-label="Get it on Google Play">
                            <img src="images/google-play.png" alt="Download on the Google Play" class="app-badge-img" />
                        </a>
                    </div>

                </div>
            </section>

            <div class="sticky-icon">
                <a href="#!" class="Instagram"> Download on App Store / Google Play </a>
                <a href="#!" class="Facebook"> Watch 60-sec Demo </a>

            </div>

        </>
    )
}

export default TheApp